import FinanceXDashboard from './FinanceXDashboard.container';

export default FinanceXDashboard;
